module.exports = __webpack_public_path__ + "img/cx_teste_glicemia.a24f5206.webp";